import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IEmployee } from 'ng2-org-chart/src/employee';
import { Router, ActivatedRoute } from '@angular/router';
import { ContactInformationVipService, EventProjectService, FrameService, CommonService } from 'src/app/shared';
import { environment } from '../../environments/environment';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as QRCode from 'qrcode';
import * as moment from 'moment';

interface TransparentRegion {
  id: number;
  color: string;
  rgb: [number, number, number];
  pixelCount: number;
}

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.css']
})
export class FrameComponent implements OnInit { 

  @ViewChild('canvas', { static: false })
  canvasRef!: ElementRef<HTMLCanvasElement>;

  transparentCount: number | null = null;
  transparentRegions: TransparentRegion[] = [];

  contactInformationVip = {"name":"","description":""};
  addForm: FormGroup;
  editForm: FormGroup;
  submitted_add = false;
  submitted_edit = false;
  currentId;
  fileName = 'Choose file';

  selectedFile: File | null = null;
  errorMessage = '';
  previewUrl: string | ArrayBuffer | null = null;

  readonly MAX_SIZE = 5 * 1024 * 1024; // 5MB
  readonly MAX_WIDTH = 1800;
  readonly MAX_HEIGHT = 1800;
  readonly ALLOWED_TYPES = ['image/jpeg', 'image/png'];
  
    constructor(private fb: FormBuilder,
      private activatedRoute: ActivatedRoute,
      private eventProjectService: EventProjectService,
      private frameService: FrameService,
      private spinner: NgxSpinnerService,
      private commonService: CommonService,
      private contactInformationVipService: ContactInformationVipService) { 
      this.addForm = fb.group({
        'name': ['', Validators.required],
        'effect_expire_date': ['', Validators.required],
        'effect_date': ['', Validators.required],
        'expire_date': ['', Validators.required],
        'file': ['', Validators.required],
        'type_clone': [''],
        'is_triple_cut': [false]
      });
  
      this.editForm = fb.group({
        'name': ['', Validators.required],
        'effect_expire_date': ['', Validators.required],
        'effect_date': ['', Validators.required],
        'expire_date': ['', Validators.required],
        'file': [''],
        'updated_at': [''],
        'type_clone': [''],
        'is_triple_cut': [false],
        'id': ['', Validators.required]
      });
    }
  
    eventProjectId
    ngOnInit() { 
      this.activatedRoute.params.forEach((urlParams) => {
        this.eventProjectId = urlParams['id'].replace('#', '');
        console.log("eventProjectId : "+this.eventProjectId);
        this.getEventProject();
      });
    }
  
    eventProjectName;
    frameList;
    originalOrder;
    orderChanged = false;
    dragIndex: number = null;
    dragOverIndex: number = null;

    onDragStart(index: number) {
      this.dragIndex = index;
    }

    onDragOver(event: DragEvent, index: number) {
      event.preventDefault();
      this.dragOverIndex = index;
    }

    onDrop(index: number) {
      if (this.dragIndex === null || this.dragIndex === index) return;
      const item = this.frameList.splice(this.dragIndex, 1)[0];
      this.frameList.splice(index, 0, item);
      this.orderChanged = true;
      this.dragIndex = null;
      this.dragOverIndex = null;
    }

    onDragEnd() {
      this.dragIndex = null;
      this.dragOverIndex = null;
    }

    saveOrder() {
      const orders = this.frameList.map((item, i) => ({ id: item.id, sort_order: i }));
      this.spinner.show();
      this.frameService.updateOrder(orders).subscribe(() => {
        this.spinner.hide();
        this.orderChanged = false;
        this.originalOrder = [...this.frameList];
        this.successDialog();
      }, err => {
        this.spinner.hide();
        this.failDialog('');
      });
    }

    cancelOrder() {
      this.frameList = [...this.originalOrder];
      this.orderChanged = false;
    }

    getEventProject(){
      this.spinner.show();
      this.frameList = [];
      this.eventProjectService.getById(this.eventProjectId).subscribe(data=>{
        this.eventProjectName = data.name;
        this.frameList = data.frames;
        this.frameList.forEach(data => {
          data["url"] = environment.api_domain+"/api/v1/files-view/"+data.file_manager_id;
        });
        this.originalOrder = [...this.frameList];
        this.orderChanged = false;
        console.log(data);
        this.spinner.hide();
      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
    }

    openCreate(){
      this.fileName = 'Choose file';
      this.selectedFile = null;
      this.errorMessage = '';
      this.previewUrl= null;

      this.addForm.patchValue({
        name: "",
        effect_expire_date: this.startDate+" - "+this.endDate,
        effect_date: this.startDate,
        expire_date: this.endDate,
        file: null,
        type_clone: '',
        is_triple_cut: false
      });
      $('#modal-create').modal({
        backdrop: 'static',
        keyboard: false
      }).modal('show');
    }

  daterange: any = {};
  startDate = this.commonService.convertDateToStrng(new Date());
  endDate = this.commonService.convertDateToStrng(new Date());
  options: any = {
    locale: { format: 'DD-MM-YYYY' },
    alwaysShowCalendars: false,
  };
  selectedDateAdd(value: any, datepicker?: any) {
    // this is the date  selected
    console.log(value);
 
    // any object can be passed to the selected event and it will be passed back here
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.startDate = this.commonService.convertDateToStrng(value.start._d);
    this.endDate = this.commonService.convertDateToStrng(value.end._d);

    this.addForm.patchValue({
      effect_expire_date: this.startDate+" - "+this.endDate,
      effect_date: this.startDate,
      expire_date: this.endDate
    });
  }
  selectedDateEdit(value: any, datepicker?: any) {
    // this is the date  selected
    console.log(value);
 
    // any object can be passed to the selected event and it will be passed back here
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.startDate = this.commonService.convertDateToStrng(value.start._d);
    this.endDate = this.commonService.convertDateToStrng(value.end._d);

    this.editForm.patchValue({
      effect_expire_date: this.startDate+" - "+this.endDate,
      effect_date: this.startDate,
      expire_date: this.endDate
    });
  }

  onFileSelected(event: any) {
    this.errorMessage = '';
    this.previewUrl = null;

    const file: File = event.target.files[0];
    if (!file) {
      this.errorMessage = 'ไฟล์ไม่ถูกต้อง';
      return;
    }

    // validate type
    if (!this.ALLOWED_TYPES.includes(file.type)) {
      this.errorMessage = 'ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF)';
      return;
    }

    // validate size
    if (file.size > this.MAX_SIZE) {
      this.errorMessage = 'ขนาดไฟล์ต้องไม่เกิน 5 MB';
      return;
    }

    // validate dimension
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.onload = () => {
        // if (img.width > this.MAX_WIDTH || img.height > this.MAX_HEIGHT) {
        //   this.errorMessage = 'ขนาดรูปต้องไม่เกิน 180 x 180 px';
        //   return;
        // }

        this.selectedFile = file;
        this.previewUrl = e.target.result;
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

    create(){
      console.log(this.addForm.value);
      this.submitted_add = true;
      if(this.addForm.invalid){
        return;
      }
      console.log(this.addForm.value);
      const formData = new FormData();
      formData.append('event_project_id', this.eventProjectId);
      formData.append('file', this.selectedFile);
      formData.append('name', this.addForm.value.name);
      formData.append('effect_date', this.addForm.value.effect_date);
      formData.append('expire_date', this.addForm.value.expire_date);
      formData.append('type_clone', this.addForm.value.type_clone);
      formData.append('is_triple_cut', this.addForm.value.is_triple_cut ? '1' : '0');

      this.spinner.show();
      this.frameService.create(formData).subscribe(data => {
        this.submitted_add = false;
        this.spinner.hide();
        $('#modal-create').modal('hide');
        this.successDialog();
        this.getEventProject();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog(error.expire_date[0]);
      });
    }
  
    openEdit(data){
      console.log(data)
      this.selectedFile = null;
      const effectDateOnly = moment(data.effect_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
      const expireDateOnly = moment(data.expire_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');

      const effectDate = moment(data.effect_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      const expireDate = moment(data.expire_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');

      let typeClone = "";
      if(data.is_clone_at){
        typeClone = "clone"
      }
      console.log(typeClone)
      this.editForm.patchValue({
        id: data.id,
        name: data.name,
        description: data.description,
        effect_expire_date: effectDateOnly+" - "+expireDateOnly,
        effect_date: effectDate,
        expire_date: expireDate,
        type_clone: typeClone,
        is_triple_cut: data.is_triple_cut == 1 || data.is_triple_cut === true,
        updated_at: data.updated_at
      });

      this.previewUrl = environment.api_domain+"/api/v1/files-view/"+data.file_manager_id+ '?v=' + data.updated_at;
      $('#modal-edit').modal({
        backdrop: 'static',
        keyboard: false
      }).modal('show');
    }

    update(){
      console.log(this.editForm.value);
      this.submitted_edit = true;
      if(this.editForm.invalid){
        return;
      }

      console.log(this.editForm.value);
      console.log(this.selectedFile);
      const formData = new FormData();
      formData.append('event_project_id', this.eventProjectId);
      formData.append('id', this.editForm.value.id);
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);
      }
      formData.append('name', this.editForm.value.name);
      formData.append('description', this.editForm.value.description);
      formData.append('effect_date', this.editForm.value.effect_date);
      formData.append('expire_date', this.editForm.value.expire_date);
      formData.append('type_clone', this.editForm.value.type_clone);
      formData.append('is_triple_cut', this.editForm.value.is_triple_cut ? '1' : '0');

      this.spinner.show();
      this.frameService.update(formData).subscribe(data => {
        this.submitted_edit = false;
        this.spinner.hide();
        $('#modal-edit').modal('hide');
        this.successDialog();
        this.getEventProject();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog(error.expire_date[0]);
      });
    }
  
    openDelete(id){
      this.currentId = id;
      $('#modal-remove').modal('show');
    }
  
    delete(){
      this.spinner.show();
      this.frameService.delete(this.currentId).subscribe(data => {
        this.spinner.hide();
        $('#modal-remove').modal('hide');
        this.successDialog();
        this.getEventProject();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog('');
      });
    }
  
    successDialog(){
      Swal.fire("ทำรายการสำเร็จ!", "", "success");
    }
  
    failDialog(msg){
      Swal.fire({
        type: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: msg
      })
    }
  
  }
